import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { fetchSuppressionListsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/suppressionListApi";

const useSuppressionListsCall = (): void => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(fetchSuppressionListsThunk());
    });
};

export default useSuppressionListsCall;
